export const WIDGET_TYPES = {
  RENT: 'rent',
  TOUR: 'tour',
};
